import { render, staticRenderFns } from "./TheQuizPreview.vue?vue&type=template&id=e39d9cf2&scoped=true&"
import script from "./TheQuizPreview.vue?vue&type=script&lang=js&"
export * from "./TheQuizPreview.vue?vue&type=script&lang=js&"
import style0 from "./TheQuizPreview.vue?vue&type=style&index=0&id=e39d9cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e39d9cf2",
  null
  
)

export default component.exports